import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../../components/ui/tooltip';
import { ShieldAlert } from 'lucide-react';

function ObjectionPanel({ objections, objectionsClicked, onToggle }) {
  return (
    <div className="mt-4">
      <h3 className="text-xs font-semibold tracking-wider text-white/40 uppercase mb-2 flex items-center gap-1">
        <ShieldAlert className="w-3.5 h-3.5" /> Objections
      </h3>
      <div className="flex flex-wrap gap-2">
        <TooltipProvider delayDuration={200}>
          {(objections || []).map((obj) => {
            const active = objectionsClicked?.includes(obj.id);
            return (
              <Tooltip key={obj.id}>
                <TooltipTrigger asChild>
                  <button
                    onClick={() => onToggle(obj.id)}
                    className={`text-xs px-3 py-1.5 rounded-lg border transition-all ${
                      active
                        ? 'bg-red-500/25 border-red-500/50 text-red-300'
                        : 'bg-red-500/10 border-red-500/30 text-red-400 hover:bg-red-500/20'
                    }`}
                  >
                    {obj.trigger_label}
                  </button>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs bg-[#0d0d0d] border-white/10 text-white/80">
                  <p className="text-xs">{obj.move}</p>
                </TooltipContent>
              </Tooltip>
            );
          })}
        </TooltipProvider>
      </div>
    </div>
  );
}

export default ObjectionPanel;
